import React, { useState } from "react";

import {
  Card,
  ListGroupItem,
  ListGroup,
  Button,
  Row,
  Form
} from "react-bootstrap";

export default function Wallet({ account, tokenContract, factoryContract }) {
  const [creatingWallet, setCreatingWallet] = useState(false);
  const [owner1, setOwner1] = useState(
    "0x9E74639034E923abAD35040a6Ad8891664b67E67"
  );
  const [owner2, setOwner2] = useState(
    "0x97149f43AF62889418063b5086F70FA58512EfA9"
  );
  const [owner3, setOwner3] = useState(
    "0xCfB798b5E2D2CE4B64Adec327709806e1b516044"
  );
  const [wallet, setWallet] = useState(null);

  const createWallet = async () => {
    try {
      const owners = [owner1, owner2, owner3];
      setCreatingWallet(true);
      const tx = await factoryContract.methods
        .createMultiSign(owners, 2)
        .send({ from: account });

      setWallet(tx.events.WalletCreated.returnValues.wallet);
      setCreatingWallet(false);
    } catch (error) {
      setCreatingWallet(false);
    }
  };
  return (
    <Row className="justify-content-center">
      <div style={{ width: "80%" }}>
        <Card className="mt-5 mb-3">
          <Card.Title className="text-center mt-3 p-3 font-weight-bold">
            MultiSig Wallet Creation
          </Card.Title>
          <Card.Body className="align-self-center" style={{ width: "80%" }}>
            {creatingWallet ? (
              <h3>Creating Wallet...</h3>
            ) : (
              <>
                <Form.Label className="bold">Owner 1</Form.Label>
                <Form.Control
                  className="mb-4"
                  type="text"
                  placeholder="0x7ffc57839b00206d1ad20c69a1981b489f772031"
                  onChange={e => setOwner1(e.target.value)}
                  value={owner1}
                />
                <Form.Label className="bold">Owner 2</Form.Label>
                <Form.Control
                  className="mb-4"
                  type="text"
                  placeholder="0x7ffc57839b00206d1ad20c69a1981b489f772031"
                  onChange={e => setOwner2(e.target.value)}
                  value={owner2}
                />
                <Form.Label className="bold">Owner 3</Form.Label>
                <Form.Control
                  className="mb-4"
                  type="text"
                  placeholder="0x7ffc57839b00206d1ad20c69a1981b489f772031"
                  onChange={e => setOwner3(e.target.value)}
                  value={owner3}
                />
              </>
            )}
          </Card.Body>
          <ListGroup className="list-group-flush">
            <ListGroupItem>
              <strong>Wallet: </strong>
              {wallet && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://rinkeby.etherscan.io/address/${wallet}`}
                >
                  {wallet}
                </a>
              )}
            </ListGroupItem>
          </ListGroup>
          <Card.Footer className="text-center">
            <Button onClick={createWallet}>Create Wallet</Button>
          </Card.Footer>
        </Card>
      </div>
    </Row>
  );
}
